module.exports = __webpack_public_path__ + "img/success-status.a0a1446e.png";